import { render, staticRenderFns } from "./ImagenClientes.vue?vue&type=template&id=69ec6b91&scoped=true&lang=pug"
import script from "./ImagenClientes.vue?vue&type=script&lang=js"
export * from "./ImagenClientes.vue?vue&type=script&lang=js"
import style0 from "./ImagenClientes.vue?vue&type=style&index=0&id=69ec6b91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ec6b91",
  null
  
)

export default component.exports